import { render, staticRenderFns } from "./CarouselV1.vue?vue&type=template&id=0d9a7506&"
import script from "./CarouselV1.vue?vue&type=script&lang=js&"
export * from "./CarouselV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports